/* person-knowledge-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./person-knowledge-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import { HorizontalScrollContainer } from '@atlassian/conversation-assistant-ui-components';
import { PersonCard } from '@atlassian/people-teams-ui/directory';
import { useActivityClient } from '@atlassian/recent-work-client';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { NLPSearchErrorState, NLPSearchResultFormat } from '../../ai-answer-dialog/types';
import { getTypedJSONResultData } from '../../ai-answer-dialog/utils/getTypedJSONResultData';
import { logger } from '../../common';
import { useAnalytics } from '../../common/controller/analytics';
import { KnowledgeCarousel } from '../../knowledge-card-components';
import { AIDisclaimerAndFeedback } from '../../v2/common/ui/ai-disclaimer-and-feedback';
import { onKnowledgeCardShown } from '../analytics';
import { fetchPrimaryUserData } from '../gql/hydrate-people-card';
import { KnowledgeCardLoading } from '../knowledge-card-loading';
import { KnowledgeCardsBody } from '../knowledge-cards-body';
import { KnowledgeCardsHeader } from '../knowledge-cards-header';
import { SeparatorLine, SeparatorLineRefresh } from '../separator-line';
import { KnowledgeCardsIntentType } from '../types';
import { formatTimeKnowledgeCard } from '../util';
import { PersonCardBody } from './person-card-body';
import { PersonCardHeader } from './person-card-header';
var ScrollableContainerStyles = {
  default: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _otyru2gc _1e0c1txw"
};
var CardContainerStyles = {
  default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
  refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
  disclaimer: "_19bvpxbi _u5f3pxbi"
};
var PersonCardWrapperStyles = {
  default: "_1bsbmgvx _1bto1l2s _o5724jg8",
  flex: "_i0dlmgvx _16jlidpf _1o9zidpf"
};
var USERS_SCROLL_OFFSET = 392;
var messages = defineMessages({
  multiple_people_matches_header: {
    id: 'search_ai.knowledge_cards.multiple_people_matches_header',
    defaultMessage: 'People matches',
    description: 'Header for the multiple people carousel'
  },
  ai_answer_component_topics_not_relevant_checkbox_label: {
    id: 'search_ai.ai_answer_component_topics_not_relevant_checkbox_label',
    defaultMessage: 'The topics are not relevant to this person.',
    description: 'Label for the checkbox asking if related topics shown for the person are relevant'
  }
});
var IndividualPersonKnowledgeCard = function IndividualPersonKnowledgeCard(_ref) {
  var _primaryUser$recentAc, _primaryUser$collabor, _primaryUser$account_, _primaryUser$account_2;
  var primaryUser = _ref.primaryUser;
  if (!primaryUser) {
    return null;
  }
  var showKnowledgeCardBody = ((primaryUser === null || primaryUser === void 0 || (_primaryUser$recentAc = primaryUser.recentActivity) === null || _primaryUser$recentAc === void 0 ? void 0 : _primaryUser$recentAc.length) || 0) > 0 || ((primaryUser === null || primaryUser === void 0 || (_primaryUser$collabor = primaryUser.collaborators) === null || _primaryUser$collabor === void 0 ? void 0 : _primaryUser$collabor.length) || 0) > 0;
  return fg('kd_people_cards_update') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles.refresh,
    testId: "individual-person-knowledge-card"
  }, /*#__PURE__*/React.createElement(PersonCardHeader, {
    accountId: primaryUser.account_id,
    name: primaryUser.name,
    email: primaryUser.email,
    avatarUrl: primaryUser.avatar_url,
    profileUrl: primaryUser.profile_url,
    jobTitle: primaryUser.job_title,
    department: primaryUser.department,
    location: primaryUser.location,
    time: primaryUser.time
  }), showKnowledgeCardBody && /*#__PURE__*/React.createElement(SeparatorLineRefresh, null), /*#__PURE__*/React.createElement(Box, null, showKnowledgeCardBody && /*#__PURE__*/React.createElement(PersonCardBody, {
    currentUserId: (_primaryUser$account_ = primaryUser.account_id) !== null && _primaryUser$account_ !== void 0 ? _primaryUser$account_ : '',
    recommendedUsers: primaryUser.collaborators || [],
    recentActivity: primaryUser.recentActivity || [],
    profileUrl: primaryUser.profile_url || ''
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: CardContainerStyles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles.default
  }, /*#__PURE__*/React.createElement(KnowledgeCardsHeader, {
    type: KnowledgeCardsIntentType.PERSON,
    accountId: primaryUser.account_id,
    name: primaryUser.name,
    email: primaryUser.email,
    avatarUrl: primaryUser.avatar_url,
    profileUrl: primaryUser.profile_url,
    jobTitle: primaryUser.job_title,
    department: primaryUser.department,
    location: primaryUser.location,
    time: primaryUser.time
  }), /*#__PURE__*/React.createElement(SeparatorLine, null), /*#__PURE__*/React.createElement(KnowledgeCardsBody, {
    type: KnowledgeCardsIntentType.PERSON,
    currentUserId: (_primaryUser$account_2 = primaryUser.account_id) !== null && _primaryUser$account_2 !== void 0 ? _primaryUser$account_2 : '',
    recommendedUsers: primaryUser.collaborators || [],
    recentActivity: primaryUser.recentActivity || [],
    profileUrl: primaryUser.profile_url || ''
  })));
};
export var PersonKnowledgeCard = function PersonKnowledgeCard(_ref2) {
  var onFMPReached = _ref2.onFMPReached;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    requestingUserId = _useAIAnswerContext.userDetails.id,
    setData = _useAIAnswerContext.setData,
    sourceProduct = _useAIAnswerContext.sourceProduct,
    loading = _useAIAnswerContext.loading;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    locale = _useIntl.locale;
  var activityClient = useActivityClient('v3', 'people');
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedUser = _useState2[0],
    setSelectedUser = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    primaryUser = _useState4[0],
    setPrimaryUser = _useState4[1];
  var answerString = commonAttributes.answerString,
    cloudId = commonAttributes.cloudId,
    workspaceId = commonAttributes.workspaceId;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPersonCardLoading = _useState6[0],
    setIsPersonCardLoading = _useState6[1];
  var userResults = getTypedJSONResultData(answerString).parsedResult;
  var ScrollWrapper = userResults.length > 3 ? function (props) {
    return /*#__PURE__*/React.createElement(HorizontalScrollContainer, null, /*#__PURE__*/React.createElement(Box, {
      xcss: ScrollableContainerStyles.default
    }, props.children));
  } : React.Fragment;
  var getHandleSelectUser = useCallback(function (index) {
    return function () {
      setSelectedUser(index);
    };
  }, []);
  useEffect(function () {
    if (userResults.length === 1) {
      setSelectedUser(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userResults]);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedUser !== undefined)) {
                _context.next = 3;
                break;
              }
              setIsPersonCardLoading(true);
              return _context.abrupt("return", fetchPrimaryUserData({
                accountId: userResults[selectedUser].id,
                tenantId: cloudId,
                requestingUserId: requestingUserId || '',
                activityClient: activityClient,
                locale: locale,
                workspaceId: workspaceId,
                product: sourceProduct !== null && sourceProduct !== void 0 ? sourceProduct : ''
              }).then(function (data) {
                setPrimaryUser(data);
              }).catch(function (error) {
                setData({
                  errorState: NLPSearchErrorState.NetworkError,
                  disclaimer: null,
                  format: NLPSearchResultFormat.JSON,
                  nlpResults: [],
                  uniqueSources: [],
                  nlpFollowUpResults: null
                });
                if (fg('kd_enable_networkerror_logging')) {
                  logger.error({
                    error: error,
                    functionName: 'fetchPrimaryUserData: PersonKnowledgeCard'
                  });
                }
              }).finally(function () {
                setIsPersonCardLoading(false);
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);
  useEffect(function () {
    onFMPReached === null || onFMPReached === void 0 || onFMPReached();
    fireAnalyticsEvent(onKnowledgeCardShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      cardType: KnowledgeCardsIntentType.PERSON
    })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if ((loading || isPersonCardLoading) && fg('kd_people_cards_update')) {
    return /*#__PURE__*/React.createElement(KnowledgeCardLoading, null);
  }
  if (userResults.length === 0) {
    return null;
  }
  if (selectedUser !== undefined || userResults.length === 1) {
    return /*#__PURE__*/React.createElement(IndividualPersonKnowledgeCard, {
      primaryUser: primaryUser
    });
  }
  if (fg('kd_people_cards_update')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, fg('kd_smart_answers_update_person_carousel') ? /*#__PURE__*/React.createElement(Stack, {
      space: "space.150"
    }, /*#__PURE__*/React.createElement(KnowledgeCarousel, {
      heading: formatMessage(messages.multiple_people_matches_header),
      scrollOffset: USERS_SCROLL_OFFSET
    }, userResults.map(function (user, index) {
      var _user$title, _user$location;
      return /*#__PURE__*/React.createElement(Box, {
        onClick: getHandleSelectUser(index),
        xcss: cx(PersonCardWrapperStyles.default, PersonCardWrapperStyles.flex),
        testId: "person-knowledge-card-wrapper",
        key: user.id
      }, /*#__PURE__*/React.createElement(PersonCard, {
        data: {
          id: user.id,
          name: user.name,
          jobTitle: (_user$title = user.title) !== null && _user$title !== void 0 ? _user$title : '',
          avatarUrl: user.avatarUrl,
          localTime: formatTimeKnowledgeCard({
            locale: locale,
            zoneInfo: user.zoneInfo
          }),
          location: (_user$location = user.location) !== null && _user$location !== void 0 ? _user$location : ''
        }
      }));
    })), /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
      showFeedbackButtons: true
    })) : /*#__PURE__*/React.createElement(Stack, {
      space: "space.150"
    }, /*#__PURE__*/React.createElement(ScrollWrapper, null, /*#__PURE__*/React.createElement(Inline, {
      space: "space.200"
    }, userResults.map(function (user, index) {
      var _user$title2, _user$location2;
      return /*#__PURE__*/React.createElement(Box, {
        onClick: getHandleSelectUser(index),
        xcss: PersonCardWrapperStyles.default,
        testId: "person-knowledge-card-wrapper",
        key: user.id
      }, /*#__PURE__*/React.createElement(PersonCard, {
        data: {
          id: user.id,
          name: user.name,
          jobTitle: (_user$title2 = user.title) !== null && _user$title2 !== void 0 ? _user$title2 : '',
          avatarUrl: user.avatarUrl,
          localTime: formatTimeKnowledgeCard({
            locale: locale,
            zoneInfo: user.zoneInfo
          }),
          location: (_user$location2 = user.location) !== null && _user$location2 !== void 0 ? _user$location2 : ''
        }
      }));
    }))), /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
      showFeedbackButtons: true
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, fg('kd_smart_answers_update_person_carousel') ? /*#__PURE__*/React.createElement(KnowledgeCarousel, {
    heading: formatMessage(messages.multiple_people_matches_header),
    scrollOffset: USERS_SCROLL_OFFSET
  }, userResults.map(function (user, index) {
    var _user$title3, _user$location3;
    return /*#__PURE__*/React.createElement(Box, {
      onClick: getHandleSelectUser(index),
      xcss: cx(PersonCardWrapperStyles.default, PersonCardWrapperStyles.flex),
      testId: "person-knowledge-card-wrapper",
      key: user.id
    }, /*#__PURE__*/React.createElement(PersonCard, {
      data: {
        id: user.id,
        name: user.name,
        jobTitle: (_user$title3 = user.title) !== null && _user$title3 !== void 0 ? _user$title3 : '',
        avatarUrl: user.avatarUrl,
        localTime: formatTimeKnowledgeCard({
          locale: locale,
          zoneInfo: user.zoneInfo
        }),
        location: (_user$location3 = user.location) !== null && _user$location3 !== void 0 ? _user$location3 : ''
      }
    }));
  })) : /*#__PURE__*/React.createElement(ScrollWrapper, null, /*#__PURE__*/React.createElement(Inline, {
    space: "space.200"
  }, userResults.map(function (user, index) {
    var _user$title4, _user$location4;
    return /*#__PURE__*/React.createElement(Box, {
      onClick: getHandleSelectUser(index),
      xcss: PersonCardWrapperStyles.default,
      testId: "person-knowledge-card-wrapper",
      key: user.id
    }, /*#__PURE__*/React.createElement(PersonCard, {
      data: {
        id: user.id,
        name: user.name,
        jobTitle: (_user$title4 = user.title) !== null && _user$title4 !== void 0 ? _user$title4 : '',
        avatarUrl: user.avatarUrl,
        localTime: formatTimeKnowledgeCard({
          locale: locale,
          zoneInfo: user.zoneInfo
        }),
        location: (_user$location4 = user.location) !== null && _user$location4 !== void 0 ? _user$location4 : ''
      }
    }));
  }))));
};